module.exports = __webpack_public_path__ + "static/media/08-speaker_profile.699ad9af.webp";